var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DoubleTickBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#4891ff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.00078,-23.03754) scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,42c-0.52734,0 -1.03906,-0.21094 -1.41406,-0.58594l-11,-11c-0.78125,-0.78125 -0.78125,-2.04687 0,-2.82812c0.78125,-0.78125 2.04688,-0.78125 2.82813,0l9.44531,9.44531l22.60156,-27.30469c0.70313,-0.85547 1.96484,-0.97266 2.8125,-0.26562c0.85156,0.70313 0.97266,1.96484 0.26563,2.8125l-24,29c-0.35547,0.4375 -0.88281,0.69922 -1.44531,0.72266c-0.03125,0.00391 -0.0625,0.00391 -0.09375,0.00391zM24.09375,41.99609c0.5625,-0.02344 1.08594,-0.28516 1.44531,-0.72266l24,-29c0.70703,-0.84766 0.58594,-2.10937 -0.26562,-2.8125c-0.84766,-0.70703 -2.10937,-0.58594 -2.8125,0.26563l-22.60156,27.30469l-0.44531,-0.44531c-0.78125,-0.78125 -2.04687,-0.78125 -2.82812,0c-0.78125,0.78125 -0.78125,2.04688 0,2.82813l2,2c0.375,0.375 0.88672,0.58594 1.41406,0.58594c0.03125,0 0.0625,0 0.09375,-0.00391z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DoubleTickBlue);
export default __webpack_public_path__ + "static/media/icons8-double-tick-blue.db37a10f36e68557e87ea09736fb07f8.svg";
export { ForwardRef as ReactComponent };